import type { ReactNode } from "react";

import { ago } from "@/lib/format";

/** Key → value row (U16) — one implementation for the three hand-rolled
 *  variants (registry drawer, live dashboard, connect). Monospace value by
 *  default; `accent` colours the underline (live-dashboard style; the default
 *  dim accent renders close to the plain registry rule). */
export function KV({ k, v, accent = "var(--t-dim)", mono = true }: {
  k: ReactNode; v: ReactNode; accent?: string; mono?: boolean;
}) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", gap: 12, fontSize: 12.5, padding: "6px 0", borderBottom: `2px solid color-mix(in srgb, ${accent} 26%, transparent)` }}>
      <span style={{ color: "var(--t-mute)", whiteSpace: "nowrap" }}>{k}</span>
      <span className={mono ? "mono" : undefined} style={{ color: v == null || v === "" ? "var(--t-dim)" : "var(--t-bright)", textAlign: "right", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontWeight: 600 }}>
        {v == null || v === "" ? "—" : v}
      </span>
    </div>
  );
}

/** "32s ago" with online/stale colouring (U18) — one staleness convention.
 *  Green while fresh, amber when past `staleAfterS` (default 300 s ≈ >3 missed
 *  90 s heartbeats), dim when never seen. */
export function Freshness({ ts, staleAfterS = 300 }: { ts: string | null | undefined; staleAfterS?: number }) {
  if (!ts) return <span style={{ color: "var(--t-dim)" }}>—</span>;
  const ageS = (Date.now() - new Date(ts).getTime()) / 1000;
  const color = ageS <= staleAfterS ? "var(--ok)" : "var(--warn)";
  return <span style={{ color }}>{ago(ts)}</span>;
}
